import { Injectable, signal } from '@angular/core';
import { PermissionDto } from './roles.service';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  permissions = signal<Record<string, boolean>>({});

  set(codes: string[] | Record<string, boolean>) {
    if (Array.isArray(codes)) {
      const map: Record<string, boolean> = {};
      codes.forEach(c => map[c] = true);
      this.permissions.set(map);
    } else {
      this.permissions.set(codes);
    }
  }

  can(code: string): boolean {
    return !!this.permissions()[code];
  }
}


